export const appHomeMapBox = {
    create: function(){
        var that = this;
        if($('.js-vhs-map').length){
            that.init();
        }
    },
    init: function(){
        var that = this;
        $('.js-vhs-map').each(function(){
            var mapID = $(this).attr('id'),
                dataMapLocations = window[mapID + 'Locations'],
                mainZoom = 13,
                startLong = dataMapLocations[0].long,
                startLat = dataMapLocations[0].lat;
            if(startLong !== undefined && startLat !== undefined){
                var thisMap = L.map(mapID).setView([startLong, startLat], mainZoom),
                    thisMarkers = [],
                    mapMarkers = [];
                L.tileLayer( 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>', subdomains: ['a','b','c'] }).addTo( thisMap );
                $.each(dataMapLocations, function(index, data) {
                    thisMarkers[index] = L.marker([data.long, data.lat]).addTo(thisMap);
                    if (data.active == 1) {
                        thisMarkers[index].bindPopup(data.popup).openPopup();
                    }
                    else {
                        thisMarkers[index].bindPopup(data.popup).closePopup();
                    }
                    mapMarkers.push(thisMarkers[index]);
                });
                if(dataMapLocations.length > 0){
                    var markerGroup = L.featureGroup(mapMarkers);
                    thisMap.fitBounds(markerGroup.getBounds());
                }
                thisMap.scrollWheelZoom.disable();
                thisMap.on('focus', () => { thisMap.scrollWheelZoom.enable(); });
                thisMap.on('blur', () => { thisMap.scrollWheelZoom.disable(); });
            }
        });
    }
};
